import type { components } from "../generated/forms-api";

type Schemas = components["schemas"];

export type QuestionType = Schemas["QuestionType"];
export const QuestionType = {
    Text: "text",
    Boolean: "boolean",
    SingleSelect: "singleSelect",
    MultiSelect: "multiSelect",
    Number: "number",
    Rating: "rating",
    Date: "date",
    RatingWithComment: "ratingWithComment",
} as const satisfies Record<string, QuestionType>;

export type FileUpload = Schemas["FileUpload"];
export const FileUpload = {
    Disabled: "disabled",
    Optional: "optional",
    Required: "required",
} as const satisfies Record<string, FileUpload>;

export type AssessmentType = Schemas["AssessmentType"];
export const AssessmentType = {
    Internal: "internal",
    External: "external",
    Feedback: "feedback",
} as const satisfies Record<string, AssessmentType>;

export type Assessment = Schemas["AssessmentSummary"];

export type Campaign = Schemas["Campaign"];

export const isSubmitted = (assessment: Pick<Assessment, "submittedAt"> | undefined): boolean => {
    return Boolean(assessment?.submittedAt);
};

export const campaignIsCompleted = (assessments: Pick<Assessment, "submittedAt">[]): boolean => {
    // if one is not submitted -> then the campaign isn't completed
    const notCompleted = assessments.find((assessment) => !isSubmitted(assessment));
    return !notCompleted;
};

export type Question = Omit<Schemas["Question"], "sectionId">;

export type Section = Omit<Schemas["Section"], "questions"> & { questions: Question[] };

export type Questionnaire = Omit<Schemas["Questionnaire"], "status" | "default" | "sections"> & { sections: Section[] };

export type Answer = Schemas["Answer"];
export type AnswerV2 = Schemas["AnswerV2"];

export type AssessmentDetail = Schemas["AssessmentDetail"];

interface EmailSignature {
    id?: number;
    content: string;
    user: string;
}

interface UserSettings {
    id: number;
    user: string;
    language: string;
    AVAILABLE_LANGUAGES: [string, string][];
}

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    client: number;
    email: string;
    username: string;
    published: boolean;
    signature: EmailSignature;
    settings: UserSettings;
    isStaff: boolean;
    isSuperuser: boolean;
    profileImage?: string;
    profilePicture?: string;
    departmentIds: number[];
    groups: string[];
    createdAt?: string;
}

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Intercom: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        heap: any;
    }
}
